import PropTypes from 'prop-types';

import AutoPayoutEligibilityStep from './AutoPayoutEligibilityStep';
import NotifyBarbersModal from './NotifyBarbersModal';
import BarbersNotifiedModal from './BarbersNotifiedModal';

const BarberBankAccountsStep = ({
  notifyBarbersModalIsOn,
  notifyBarbersModalOff,
  onSendBarberEmails,
  barbersWithIssues,
  barbersNotifiedModalIsOn,
  onCloseBarbersNotifiedModal,
  barbersNotifiedResult,
  ...otherProps
}) => (
  <>
    <AutoPayoutEligibilityStep {...otherProps} />
    <NotifyBarbersModal
      display-if={notifyBarbersModalIsOn}
      onClose={notifyBarbersModalOff}
      barbersWithIssues={barbersWithIssues}
      onNotifyClicked={onSendBarberEmails}
    />
    <BarbersNotifiedModal
      display-if={barbersNotifiedModalIsOn}
      onClose={onCloseBarbersNotifiedModal}
      barbersNotifiedResult={barbersNotifiedResult}
    />
  </>
);

BarberBankAccountsStep.propTypes = {
  notifyBarbersModalIsOn: PropTypes.bool.isRequired,
  notifyBarbersModalOff: PropTypes.func.isRequired,
  onSendBarberEmails: PropTypes.func.isRequired,
  barbersWithIssues: PropTypes.arrayOf(PropTypes.object).isRequired,
  barbersNotifiedModalIsOn: PropTypes.bool.isRequired,
  onCloseBarbersNotifiedModal: PropTypes.func.isRequired,
  barbersNotifiedResult: PropTypes.arrayOf(PropTypes.object).isRequired,
};
export default BarberBankAccountsStep;
